export default __webpack_public_path__ + "static/media/E-commerceRealCase1-en.d66fc793.jpg";